import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const restApi = {
  cuisines: () => axios.get(`${API}/restaurants/cuisines`).then(r => r.data),
  list: (params = {}) => {
    const usp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== "" && v !== null && v !== undefined && v !== false) usp.set(k, v);
    });
    return axios.get(`${API}/restaurants?${usp}`).then(r => r.data);
  },
  detail: (rid) => axios.get(`${API}/restaurants/${rid}`).then(r => r.data),
};

export const PRICE_RANGES = [
  { id: "$", label: "$" },
  { id: "$$", label: "$$" },
  { id: "$$$", label: "$$$" },
  { id: "$$$$", label: "$$$$" },
];

export const REST_SORTS = [
  { id: "rating", label: "Mejor valorados" },
  { id: "reviews", label: "Más populares" },
  { id: "distance", label: "Más cercanos" },
  { id: "recent", label: "Más recientes" },
];
